/* ============================================================
   INDSO — article.js
   Copy-link button for the article share row.
   ============================================================ */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  ready(() => {
    document.querySelectorAll('[data-copy-link]').forEach((link) => {
      link.addEventListener('click', async (e) => {
        e.preventDefault();
        const url = link.dataset.url || window.location.href;
        const original = link.textContent;
        try {
          await navigator.clipboard.writeText(url);
        } catch (err) {
          // Fallback for older browsers
          const tmp = document.createElement('textarea');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); } catch (e2) { /* noop */ }
          document.body.removeChild(tmp);
        }
        link.textContent = link.dataset.copied || 'Copied!';
        setTimeout(() => { link.textContent = original; }, 1800);
      });
    });
  });
})();
